import { render, staticRenderFns } from "./OrganizationEditDetail.vue?vue&type=template&id=e5f62d5a&scoped=true"
import script from "./OrganizationEditDetail.vue?vue&type=script&lang=js"
export * from "./OrganizationEditDetail.vue?vue&type=script&lang=js"
import style0 from "./OrganizationEditDetail.vue?vue&type=style&index=0&id=e5f62d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f62d5a",
  null
  
)

export default component.exports